import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as LocalStorage from "../../utils/localStorage";
import "./headerStyling.css";
import {
  FaTachometerAlt,
  FaShoppingCart,
  FaUserAlt,
  FaCaretUp,
  FaSignOutAlt
} from "react-icons/fa";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menu, setMenu] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const menuButton = useRef(null);
  function menuClick() {
    if (menu) {
      setMenu(false);
    } else {
      setMenu(true);
    }
  }

  const onLogout = () => {
    navigate("/");
    LocalStorage.setLSValue("user", false);
  };
  useEffect(() => {
    if (LocalStorage.getLSValue("user")) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);
  return (
    <header>
      <div
        className={menu ? "header-div header-div-small-screens" : "header-div"}
      >
        <div className="logo-div">
          <p className="logo">Product Admin</p>
        </div>
        <button className="nav-menu" onClick={menuClick} ref={menuButton}>
          <FaCaretUp
            className={menu ? "menu-icon menu-icon-rotate" : "menu-icon"}
          />
        </button>
        <nav className={menu ? "header-nav-small-screens" : "header-nav"}>
          <ul className={menu ? "nav-links nav-links-small" : "nav-links"}>
            <li
              key="Dashboard"
              className={
                location.pathname.includes("/dashboard")
                  ? "nav-link nav-link-active"
                  : "nav-link"
              }
            >
              <Link to="/dashboard" className={!isLoggedIn ?"nav-link-a tooltip":"nav-link-a"}>
                <div className="nav-link-logo">
                  <FaTachometerAlt />
                </div>
                Dashboard
                {!isLoggedIn &&<span className="tooltiptext">To proceed, kindly log in.</span>}
              </Link>
            </li>
            <li
              key="Products"
              className={
                location.pathname.includes("/products")
                  ? "nav-link nav-link-active"
                  : "nav-link"
              }
            >
              <Link to="/products" className={!isLoggedIn ?"nav-link-a tooltip":"nav-link-a"}>
                <div className="nav-link-logo">
                  <FaShoppingCart />
                </div>
                Products
                {!isLoggedIn &&<span className="tooltiptext">To proceed, kindly log in.</span>}
              </Link>
            </li>
            <li
              key="Accounts"
              className={
                location.pathname.includes("/accounts")
                  ? "nav-link nav-link-active"
                  : "nav-link"
              }
            >
              <Link to="/accounts" className={!isLoggedIn ?"nav-link-a tooltip":"nav-link-a"}>
                <div className="nav-link-logo">
                  <FaUserAlt />
                </div>
                Accounts
                {!isLoggedIn &&<span className="tooltiptext">To proceed, kindly log in.</span>}
              </Link>
            </li>
          </ul>
          {isLoggedIn && (
            <div className="logout-div" onClick={onLogout}>
              <button className="logout-button">
                <FaSignOutAlt className="logout-icon" /> Logout
              </button>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;
